import { component } from 'picoapp';
import { subscribe } from 'klaviyo-subscribe';

export default component(async (node) => {
  const submit = node.querySelector('button[data-submit]');
  const emailField = node.querySelector('input');
  const { list } = node.dataset;

  const closeButton = node.querySelectorAll('[data-close]');
  const toggle = document.querySelector('[data-preorder-btn]');
  const successMessage = node.querySelector('[data-success]');

  closeButton.forEach((btn) => {
    btn.addEventListener('click', () => {
      node.hidden = true;
    });
  });

  toggle.addEventListener('click', () => {
    node.hidden = false;
  });

  const validateEmail = (email) => email.match(
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  );

  emailField.addEventListener('focus', () => {
    emailField.style.borderColor = null;
  });

  submit.addEventListener('click', () => {
    if (validateEmail(emailField.value)) {
      subscribe(list, emailField.value).then((response) => {
        if (response.success) {
          emailField.hidden = true;
          submit.hidden = true;
          successMessage.hidden = false;
        }
      });
    } else {
      emailField.style.borderColor = '#dc2626';
    }
  });
});
